import Footer from './Footer';

const ProcessingPayment: React.FC = () => {
  return (
    <div className="flex flex-col w-full justify-center">
      <div className="flex flex-col items-center  justify-center py-16">
        <div className="flex items-center mb-8 justify-center space-x-2">
          <div
            className="w-3 h-3 bg-pink rounded-full animate-bounce"
            style={{animationDelay: '0s'}}
          />
          <div
            className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"
            style={{animationDelay: '0.2s'}}
          />
          <div
            className="w-3 h-3 bg-cyan-500 rounded-full animate-bounce"
            style={{animationDelay: '0.4s'}}
          />
        </div>
        <h2 className="text-[28px] text-displayBlack font-semibold mb-2 text-center">
          Processing Payment
        </h2>
        <p className=" text-secondaryGrayscale font-normal text-xs flex items-center">
          ☕ Hang tight. This may take a second.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default ProcessingPayment;
